import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import { computed } from '@vue/composition-api';
import { formatBalance } from '@src/app/utils/balance';

export function useFormattedBalance() {
    const authModule = useVuexStore<typeof authStore>('data/authentication');

    const user = authModule.getter('user');
    const currentBalance = computed(() => user.value?.balance?.realMoney.total);

    const formattedBalance = computed(() => {
        if (currentBalance.value != null) {
            return formatBalance(currentBalance.value);
        }
        return '';
    });

    return {
        formattedBalance,
    };
}
